export default function getLocalDateStringFromTimestamp(timestamp: number) {
  const date = new Date(timestamp);
  return `${date.toLocaleString('de-CH')}`;
}
